import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';
import { Moment } from 'moment';

import {
  TEFReceiptPrintTargetEnum,
  TEFReceiptPrintTypeEnum,
} from '@/types/Tef';

export enum DateTypeEnum {
  Sale = 'SALE',
  Authorization = 'AUTHORIZATION',
  Cancellation = 'CANCELLATION',
}

export enum lsSituacaoEnum {
  Open = 'OPEN',
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
}

export enum ReportTypeEnum {
  SalesSummary = 'sales-summary',
  SalesTotal = 'sales-total',
  SalesSeller = 'sales-seller',
}

export enum GroupBySaleSummaryEnum {
  SITUATION = 'SITUATION',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
}
export interface ReportDirectSaleFormValues extends ReportDateInterface {
  dateType: DateTypeEnum;
  lsSituacao: lsSituacaoEnum;
  reportType: ReportTypeEnum;
  customersIds: number[];
  employeesIds: number[];
  tagsIds: number[];
  synthetic?: boolean;
}

export interface ReportDirectSaleSaleSummaryFormValues
  extends ReportDirectSaleFormValues {
  groupBySaleSummary: GroupBySaleSummaryEnum;
}

export interface ReportDirectSaleRequest extends ReportDirectSaleFormValues {
  format: string;
}

export interface ReportDirectSaleSaleRequest
  extends ReportDirectSaleSaleSummaryFormValues {
  format: string;
}

export interface DirectSaleDataRequest {
  id: number;
  situation: string;
  grossValue: number;
  discountValue: number;
  liquidValue: number;
}

export interface DirectSaleSellerSyntheticDataRequest
  extends DirectSaleDataRequest {
  employeeId: number;
  nameEmployee: string;
}

export interface DirectSaleSummaryPeriodDataRequest
  extends DirectSaleDataRequest {
  labelGrouping: string;
  groupBySaleSummary: string;
}

export interface DirectSaleTotalDataRequest
  extends DirectSaleDataRequest,
    DirectSaleSellerSyntheticDataRequest {
  code: string;
  dateFilter: string;
  nameCustomer: string;
  createDate: Moment;
  authorizationDate: Moment;
  cancellationDate: Moment;
}

export interface ReportDirectSalePaymentReceipt {
  format: 'PDF';
  saleId: number;
  receiptPrintTarget?: TEFReceiptPrintTargetEnum;
  receiptPrintType?: TEFReceiptPrintTypeEnum;
  showCustomerDocument?: boolean;
}
